import React from "react";
import TextCard from "../../text-card";
import ImageCard from "../../image-card";

const InlineLayout = (props) => {
  const cards = Object.keys(props)
    .filter((key) => key.includes("Image-Card"))
    .map((key) => props[key]);

  return (
    <div
      className="inline-container"
      data-cy="Inline Layout"
      style={{ backgroundColor: props?.backgroundColor || "white" }}
    >
      <div className="container">
        <div className="row inline-layout">
          <div
            className="col-xs-12 col-sm-12 col-md-3 text-card"
            data-cy="Text Card"
          >
            {props?.["Text-Card-1"] && <TextCard {...props["Text-Card-1"]} />}
          </div>

          <div
            className={`col-xs-12 col-sm-12 col-md-9 image-cards image-cards--${props?.direction}`}
            data-cy="Image Cards"
          >
            {cards.map(
              (cardData, i) =>
                cardData && (
                  <ImageCard {...cardData} isSmall key={`card-${i}`} />
                )
            )}
          </div>

          <div></div>
        </div>
      </div>
    </div>
  );
};

export default InlineLayout;
